import React, { useState, useEffect, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Input from "./input";
import { savtruckover } from "./../../services/wms";
import { toast } from "react-toastify";
import BranchContext from "./../context/branch";
const Modaltruckover = ({
  button1,
  isOpen,
  header,
  onCancel,
  onConfirm,
  message,
  list,
  onDisAprove,
  value,
  onChange,
  onProgress,
  error,
  size = "lg",
}) => {
 
  const { currentBranch } = useContext(BranchContext);
  const [comment, setcomment] = useState("");
  

  useEffect(() => {
    if (!currentBranch) return;
    if (!list) return;
    if (list && list.length> 0 ){
      setcomment("");

    }

    
  }, [currentBranch, list]);


  const handelchang = ({ currentTarget: input }) => {
    setcomment(input.value);
  };
  const SavedoSubmit = async () => {
    if (comment === "") {
      toast.error("กรุณาใส่เหตุผล ค่ะ");
      return;
    }
    try {
      onProgress(true);
      const doc = {
        weightno: list[0].weight_no,
        comment: comment,
      };
      const { data: result } = await savtruckover(doc);
      if (result.status === "success") {
        toast.success("บันทึกเสร็จเรียบร้อย");
        onCancel(false);
        onProgress(false);
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      toast.error("Error Try Catch");
    }
  };
  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader>
          {list && list.length > 0 && (
            <div className="row" style={{ fontSize: "16px" }}>
              <span
                style={{ fontSize: "16px" }}
                className="font-weight-normal badge bg-danger"
              >
                ระบุข้อมูลรถเกินเวลา
              </span>
              {"  "}
              <div className="ms-2">เลขใบชั่ง : {list[0].Receive_truckNo}</div>
            </div>
          )}
        </ModalHeader>
        <ModalBody>
          {list && list.length > 0 && (
            <>
              <div className="row mb-1" style={{ fontSize: "14px" }}>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  ลูกค้า : {list[0].Customer_Name}
                </div>

                <div className="col-lg-4  col-sm-6 col-xs-12">
                  ประเภทลูกค้า : {list[0].customertypename}
                </div>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <span
                    className="badge badge-pill badge"
                    style={{ fontSize: "15px" }}
                  >
                    นน.ชั่งเข้า : {list[0].receive_weightin}
                  </span>
                </div>
              </div>
              <div className="row mb-4" style={{ fontSize: "14px" }}>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  สินค้า : {list[0].ProductName}
                </div>

                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <span
                    className="badge badge-pill badge"
                    style={{ fontSize: "14px" }}
                  >
                    ทะเบียน : {list[0].First_Driven_No}{" "}
                    {list[0].FirstProvinceCode}
                  </span>
                </div>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <span
                    className="badge badge-pill badge"
                    style={{ fontSize: "14px" }}
                  >
                    ทะเบียนหาง : {list[0].Second_driven_no}{" "}
                    {list[0].ProvinceCode}
                  </span>
                </div>
              </div>

              {list[0].commentlist.length > 0 &&
                list[0].commentlist.map((item, index) => (
                  <div key={index} className="row mt-2">
                    <div className="col-lg-3  col-sm-6 col-xs-12">
                      <span
                        style={{ fontSize: "13px" }}
                        className="badge rounded-pill bg-secondary"
                      >
                        {index + 1}
                      </span>{" "}
                      <span
                        className="badge  badge-warning"
                        style={{ fontSize: "13px" }}
                      >
                        {item.comment}
                      </span>
                    </div>

                    <div className="col-auto">
                      <span
                        className="badge badge-pill badge"
                        style={{ fontSize: "13px" }}
                      >
                        วันทึกเมื่อ : {item.daterecord}
                      </span>
                    </div>
                    <div className="col-auto">
                      <span
                        className="badge badge-pill badge"
                        style={{ fontSize: "13px" }}
                      >
                        โดย : {item.firstname}
                      </span>
                    </div>
                    <div className="col-auto">
                      <span
                        className="badge badge-pill badge"
                        style={{ fontSize: "13px" }}
                      >
                        นาทีที่ :
                      </span>
                      <span
                        className="badge rounded-pill bg-danger"
                        style={{ fontSize: "13px" }}
                      >
                        {item.timeminute}
                      </span>
                    </div>
                  </div>
                ))}

              <div className="col-lg-10  col-sm-6 col-xs-12">
                <Input
                  type="text"
                  name="comment"
                  value={comment}
                  onChange={handelchang}
                  placeholder="กรุณาระบุเหตุผล"
                />
              </div>
            </>
          )}
          {!list && message}
        </ModalBody>
        {error && <div className="col-md-12 alert alert-danger"> {error}</div>}

        {list && list.comment && <Button color="danger">{list.comment}</Button>}
        <ModalFooter>
          <Button color="primary" onClick={SavedoSubmit}>
            Save
          </Button>
          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Modaltruckover;
